import { Box, Container, Stack, Typography } from '@mui/material';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import type { ReactNode } from 'react';

interface Credential {
  icon: ReactNode;
  title: string;
  detail: string;
}

const items: ReadonlyArray<Credential> = [
  {
    icon: <SchoolRoundedIcon />,
    title: 'Townsend Institute',
    detail: 'Executive Coaching & Consulting at Concordia University Irvine',
  },
  {
    icon: <VerifiedRoundedIcon />,
    title: 'ICF-Aligned Practice',
    detail: 'Coaching grounded in International Coaching Federation principles',
  },
  {
    icon: <GroupsRoundedIcon />,
    title: 'Decade of Leadership',
    detail: '10+ years leading teams in pastoral, athletic, and corporate contexts',
  },
];

export function Credentials() {
  return (
    <Box
      component="section"
      id="credentials"
      sx={{
        backgroundColor: 'primary.dark',
        color: 'primary.contrastText',
        py: { xs: 8, md: 12 },
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2} sx={{ textAlign: 'center', alignItems: 'center', mb: { xs: 5, md: 7 } }}>
          <Typography
            variant="overline"
            sx={{ color: 'rgba(245, 241, 232, 0.7)', letterSpacing: '0.22em' }}
          >
            Credentials
          </Typography>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              color: 'primary.contrastText',
              fontSize: { xs: '1.75rem', md: '2.25rem' },
            }}
          >
            Trained, certified, tested in the room.
          </Typography>
        </Stack>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: { xs: 3, md: 4 },
          }}
        >
          {items.map((it) => (
            <Stack
              key={it.title}
              spacing={2}
              sx={{
                alignItems: 'flex-start',
                p: 4,
                border: '1px solid rgba(245, 241, 232, 0.18)',
                borderRadius: 1,
              }}
            >
              <Box
                sx={{
                  color: 'secondary.main',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {it.icon}
              </Box>
              <Typography
                variant="h6"
                component="h3"
                sx={{ color: 'primary.contrastText', fontFamily: '"Inter", sans-serif', fontWeight: 600 }}
              >
                {it.title}
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(245, 241, 232, 0.75)' }}>
                {it.detail}
              </Typography>
            </Stack>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
